import has from 'lodash/has';
import isPlainObject from 'lodash/isPlainObject';
import mapValues from 'lodash/mapValues';
import merge from 'lodash/merge';

export function addListToSet(list, set) {
  return set.withMutations(mutable => {
    list.forEach(value => {
      mutable.add(value);
    });
  });
}

export function toJS(value) {
  return value.toJS ? value.toJS() : value;
}

export function mergeDeepRecursive(map, input = {}) {
  const source = toJS(input);

  const output = mapValues(source, (value, key) => {
    return isPlainObject(value) ? merge(map.get(key, {}), value) : value;
  });

  map
    .keySeq()
    .toArray()
    .forEach(key => {
      output[key] = !has(output, key) ? map.get(key) : output[key];
    });

  return map.mergeDeep(output);
}
